// extracted by mini-css-extract-plugin
module.exports = {"noIcon":"ArchiveTarget_noIcon__1ow0j","image":"ArchiveTarget_image__3geU-"};